import { render, staticRenderFns } from "./configuration-price-display.vue?vue&type=template&id=07c842c1&"
import script from "./configuration-price-display.vue?vue&type=script&lang=js&"
export * from "./configuration-price-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports